import type { Maybe } from "graphql/jsutils/Maybe";
import dayjs from "dayjs";

import type { Languages } from "@/common/utils/constants";
import { formatDate } from "../../../../utils/formatDate";
import ReceiptDetailsTitleSection from "../../../common/ReceiptDetailsTitleSection/ReceiptDetailsTitleSection";

export interface ProratedSectionProps {
    currency: Maybe<string>;
    totalProratedPrice: string | number;
    oldProratedPrice: string | number;
    lang: Languages;
    selectedStartDate: Date;
    translations: Record<string, string>;
}

export const ProratedSection = ({
    currency,
    totalProratedPrice,
    oldProratedPrice,
    lang,
    selectedStartDate,
    translations 
}: ProratedSectionProps) => {

    const endOfProrata = dayjs(selectedStartDate).endOf("month").format("YYYY-MM-DD");

    const formattedEndOfProrata = formatDate(new Date(endOfProrata), lang);
    const formattedSelectedDate = formatDate(new Date(selectedStartDate), lang);

    const totalOldProratedPrice =
        Number(oldProratedPrice) !== Number(totalProratedPrice) ? oldProratedPrice : "";

    return (
        <ReceiptDetailsTitleSection
            title={translations["becomeamember.floatingreceipt.prorata"]}
            currency={currency as string}
            price={String(totalProratedPrice)}
            oldPrice={totalOldProratedPrice}
            additionalText={
                formattedSelectedDate === formattedEndOfProrata
                    ? `${formattedSelectedDate}`
                    : `${formattedSelectedDate} - ${formattedEndOfProrata}`
            }
        />
    );
};